import { UrlParamsKeys } from '@config/keys/url-params.keys';

import { ContentBuilderSpecMode } from './content-builder-spec.model';

/** Compiled spec mode from `?cb_mode=`. Only `draft` opts out of live. */
export function readContentBuilderSpecModeFromUrl(url: string): ContentBuilderSpecMode {
  const queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return 'live';
  }
  const hashIndex = url.indexOf('#', queryIndex);
  const query = url.slice(queryIndex + 1, hashIndex === -1 ? undefined : hashIndex);
  return new URLSearchParams(query).get(UrlParamsKeys.CbMode) === 'draft' ? 'draft' : 'live';
}
